module.exports = __webpack_public_path__ + "img/erweima.0d1bea91.png";